import { ORDER_PLACED } from "../../constants/orderStatus";

// 注文番号の表記(6桁ゼロ埋め)。採番トランザクションとカウンタdocの両方で使う。
export const formatOrderNumber = (orderNumber) =>
  String(orderNumber).padStart(6, "0");

// 注文docの生成(ordersコレクションのスキーマ定義)。
// 純関数のためJestで直接テストできる。フィールド構成はCSVエクスポート
// (functions/export.js)や各集計処理と対応しているので、変更時は互換性に注意。
export const buildOrderData = ({
  orderId,
  orderDocId,
  orderNumber,
  orderInfo,
  product,
  amount,
  deductionAmount,
  timestamp,
  clientBuildId,
}) => ({
  // 共通の注文情報
  order_id: orderId, // カートID
  id: orderDocId, // ドキュメントID
  order_number: orderNumber, // 注文番号

  order_user_id: Number(orderInfo.order_user_id), //発注担当者社員番号
  order_user_name: orderInfo.order_user_name, //発注担当者名
  order_user_dep_id: Number(orderInfo.order_user_dep_id), //発注担当者部署コード
  order_user_dep_name: orderInfo.order_user_dep_name, //発注担当者部署名
  order_user_email: orderInfo.order_user_email, //発注担当者メールアドレス
  order_base_id: orderInfo.order_base_id, //発注拠点コード
  order_base_name: orderInfo.order_base_name, //発注拠点名
  order_department_id: orderInfo.order_department_id, //発注部署コード
  order_department_name: orderInfo.order_department_name, //発注部署名

  billing_user_flg: orderInfo.billing_user_flg, //購入依頼者有無
  billing_user_id: Number(orderInfo.billing_user_id), //購入依頼者社員番号
  billing_user_name: orderInfo.billing_user_name, //購入依頼者名
  billing_user_dep_id: orderInfo.billing_user_dep_id, //購入依頼者部署コード
  billing_user_dep_name: orderInfo.billing_user_dep_name, //購入依頼者部署名

  billing_company_flg: orderInfo.billing_company_flg, //仕入先有無
  billing_company_id: Number(orderInfo.billing_company_id), //仕入先コード
  billing_company_name_full: orderInfo.billing_company_name_full, //仕入先名
  billing_company_name: orderInfo.billing_company_name, //仕入先略称

  remark_on_order: orderInfo.remark_on_order, //注文に関する備考

  delivery_office_id: Number(orderInfo.delivery_office_id), //納入先事業所コード
  delivery_office_name: orderInfo.delivery_office_name, //納入先事業所名
  delivery_office_address_main: orderInfo.delivery_office_address_main, //納入先事業所住所1
  delivery_office_address_sub: orderInfo.delivery_office_address_sub, //納入先事業所住所2
  delivery_office_tell: orderInfo.delivery_office_tell, //納入先事業所電話番号

  delivery_department: orderInfo.delivery_department, //納入先部署

  amount: Number(amount), // カート単位の合計金額
  deduction_amount: Number(deductionAmount), //カート単位の控除後合計金額
  // 商品ごとの情報
  product_id: product.productId, // 商品ID
  category_id: product.category, //カテゴリID
  category_name: product.category_name, //カテゴリ名
  description: product.description, //商品説明
  idin: product.idin, //社内番号
  idout: product.idout, //社外番号
  images: product.images, //画像
  name: product.name, //商品名
  price: Number(product.price), //価格
  quantity: Number(product.quantity), //数量
  totalPrice: Number(product.totalPrice), //合計金額
  deduction_price: Number(product.deduction_price), //控除金額

  deduction_id: product.deduction_id, //控除区分
  deduction_name: product.deduction_name, //控除区分名
  deduction_is_valid: product.deduction_is_valid, //控除区分が適用できるか
  deduction_correct_count: Number(product.deduction_correct_count), //控除区分が適用できる数量
  size: product.size, //サイズ
  maker_id: product.maker, //メーカーID
  maker_name: product.maker_name, //メーカー名
  shop_id: product.shop, //販売先ID
  shop_name: product.shop_name, //販売店名
  shop_fax: product.shop_fax, //販売店FAX
  shop_to: product.shop_to, //販売店宛名
  shop_cc: product.shop_cc, //販売店CC
  embroidery: product.embroidery, //刺繍
  remarks: product.remarks, //備考
  added_at: product.added_at, //カート追加日時

  status: ORDER_PLACED, // 状態

  placed_at: timestamp, //注文日時
  ordered_at: null, //発注日時
  received_at: null, // 検収日日時
  canceled_at: null, //キャンセル日時

  login_user_uid: orderInfo.login_user_uid, //ログインユーザUID
  login_user_dep_id: orderInfo.login_user_dep_id, //ログインユーザ部署コード
  login_user_dep_name: orderInfo.login_user_dep_name, //ログインユーザ部署名
  login_user_email: orderInfo.login_user_email, //ログインユーザメールアドレス
  login_user_id: orderInfo.login_user_id, //ログインユーザ社員番号
  login_user_name: orderInfo.login_user_name, //ログインユーザ社員名
  login_user_role: orderInfo.login_user_role, //ログインユーザ権限
  updated_at: timestamp, //最終更新日時
  created_at: timestamp, //作成日時
  update_user_email: orderInfo.login_user_email, //最終更新者メールアドレス
  create_user_email: orderInfo.login_user_email, //作成者メールアドレス

  // このdocを作成したアプリのビルドID。
  // firestore.rulesが「最新ビルド以上」を要求するため、旧ビルドからの注文はサーバで拒否される
  client_build_id: Number(clientBuildId),
});
